const DEMO_CREDENTIALS = {
  email: process.env.REACT_APP_EMAIL,
  password: process.env.REACT_APP_PASSWORD
};

export { DEMO_CREDENTIALS };
